var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule"},[_c('p',[_vm._v("1、每日一题答题成功后可获取5积分")]),_c('p',[_vm._v("2、视频打卡成功后可获取1积分")]),_c('p',[_vm._v("3、作业上传批改后可以获取5积分。")])])}]

export { render, staticRenderFns }